<template>
  <div class="messenger-popover-layout">
    <div class="messenger-popover">
      <slot />
    </div>
  </div>
</template>

<style lang="scss" scoped>
@import '@/styles/custom-variables.scss';

.messenger-popover-layout {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: flex-end;
  background-color: rgba($gray9, 0.6);
  position: relative;
  z-index: 100;
  border-radius: 20px;
}

.messenger-popover {
  width: 100%;
  background: $white;
  border-radius: 20px;
  padding: 28px 24px 24px;
}
</style>
